import { graphql, useFragment } from 'react-relay';

import {
  ScrapSourceScrapConnectionDataTable_scrapConnection$data,
  ScrapSourceScrapConnectionDataTable_scrapConnection$key,
} from '../../../relay/__generated__/ScrapSourceScrapConnectionDataTable_scrapConnection.graphql';
import DataTable, { DataTableProps } from '../../core/DataTable';
import Text from '../../core/Text';

const ScrapSourceScrapConnectionDataTable_scrapConnection = graphql`
  fragment ScrapSourceScrapConnectionDataTable_scrapConnection on ScrapConnection {
    totalCount
    edges {
      node {
        id
        actions
        problemNumber
        problemBookPage
        solutionBookPage
        task {
          id
          sequence
          isDeleted
        }
      }
    }
  }
`;

type Props = { scrapConnection: ScrapSourceScrapConnectionDataTable_scrapConnection$key } & Omit<
  DataTableProps<ScrapSourceScrapConnectionDataTable_scrapConnection$data['edges'][number]['node']>,
  'rows' | 'columns'
>;

const ScrapSourceScrapConnectionDataTable = ({ scrapConnection, ...props }: Props) => {
  const { edges, totalCount } = useFragment(ScrapSourceScrapConnectionDataTable_scrapConnection, scrapConnection);
  return (
    <DataTable
      rows={edges.map(({ node }) => node).filter((node) => !!node)}
      columns={[
        {
          field: 'index',
          // 목록은 마지막에 스크랩한 것부터 내려오므로 번호도 총 개수에서 거꾸로 센다.
          title: '',
          renderValue: (_, index) => <Text fontSize={1}>{(totalCount ?? edges.length) - index}</Text>,
          width: 30,
        },
        {
          field: 'problem',
          title: '문제',
          renderValue: ({ problemBookPage, problemNumber }) => (
            <Text fontSize={1}>{`${problemBookPage}P의 ${problemNumber}`}</Text>
          ),
          width: 120,
        },
        {
          field: 'solution',
          title: '해설',
          renderValue: ({ solutionBookPage }) => <Text fontSize={1}>{solutionBookPage}P</Text>,
          width: 120,
        },
        {
          field: 'task',
          // 연결된 task 가 없으면 제출할 때 새로 만들어진다. 삭제된 task 는 다시 만들지 않는다.
          title: '문항',
          renderValue: ({ task }) =>
            task ? (
              <Text fontSize={1} color={task.isDeleted ? 'fg.subtle' : undefined}>
                {task.isDeleted ? `${task.sequence} (삭제됨)` : task.sequence}
              </Text>
            ) : (
              <Text fontSize={1} color={'accent.fg'}>
                생성 예정
              </Text>
            ),
          width: 120,
        },
      ]}
      {...props}
    />
  );
};

export default ScrapSourceScrapConnectionDataTable;
